import { render, staticRenderFns } from "./PassSafeGuardIdVerifyCert.vue?vue&type=template&id=0d56a018&"
import script from "./PassSafeGuardIdVerifyCert.vue?vue&type=script&lang=js&"
export * from "./PassSafeGuardIdVerifyCert.vue?vue&type=script&lang=js&"
import style0 from "./PassSafeGuardIdVerifyCert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports